import SelectFranchiseModal from './view';

export default SelectFranchiseModal;
